export enum EMMA_EVENTS {
  AUTO_EVENT = 'emma_auto_event',
  END_SESSION = 'emma_end_session',
  FIRST_LOGIN = 'emma_login',
  INSTALL = 'emma_install',
  LOGIN = 'emma_login2',
  REGISTER = 'emma_register',
  REINSTALL = 'emma_reinstall',
  REOPEN = 'emma_reopen',
  SESSION = 'emma_start_session',
  TRANSACTION = 'emma_transaction',
  RETARGETING_OPEN = 'emma_retargeting_open',
}

export enum EMMA_EVENTS_NAMES {
  AUTO_EVENT = 'AUTO EVENT',
  END_SESSION = 'END SESSION',
  FIRST_LOGIN = 'FIRST LOGIN',
  INSTALL = 'INSTALL',
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  REINSTALL = 'REINSTALL',
  REOPEN = 'REOPEN',
  SESSION = 'SESSION',
  TRANSACTION = 'TRANSACTION',
  RETARGETING_OPEN = 'RETARGETING_OPEN',
}

export enum EVENT_CATEGORY {
  SCREEN = 'screen',
  CUSTOM = 'custom',
  DEFAULT = 'default',
}

export const MAX_SKAN_VALUE = 63;
export const MIN_SKAN_VALUE = 1;
export const DEFAULT_SKAN_VALUE = -1;
export const EMMA_EVENT_ATTRIBUTE_SCREEN_NAME = 'e_screen_name';
